module.exports = __webpack_public_path__ + "media/researchers.0420d255.mp4";